import { api } from "./apiClient";

export const projectsAPI = {
    getAll: () => api.get("/projects"),
    create: (payload) => api.post("/projects", payload),
    getOne: (projectId) => api.get(`/projects/${projectId}`),
    update: (projectId, payload) =>
        api.patch(`/projects/${projectId}`, payload),

    getMyRole: (projectId) => api.get(`/projects/${projectId}/my-role`),

    getTeam: (projectId) => api.get(`/projects/${projectId}/team`),
    getTeamCandidates: (projectId) => api.get(`/projects/${projectId}/team-candidates`),
    addTeamMember: (projectId, payload) =>
        api.post(`/projects/${projectId}/team`, payload),
    deactivateTeamMember: (projectId, memberId) =>
        api.patch(`/projects/${projectId}/team/${memberId}/deactivate`),

    getOrgChart: (projectId) => api.get(`/projects/${projectId}/org-chart`),
    getOrgChartHistory: (projectId) =>
        api.get(`/projects/${projectId}/org-chart/history`),
    validateOrgChart: (projectId, payload) =>
        api.post(`/projects/${projectId}/org-chart/validate`, payload),
    saveOrgChart: (projectId, payload) =>
        api.put(`/projects/${projectId}/org-chart`, payload),
};
